// =========================================================
// FIX: Poll until owlCarousel is available, then init all
// This handles Pagefly dynamic script injection on reload
// =========================================================
function initAllCarousels() {
  if (typeof jQuery.fn.owlCarousel === 'undefined') {
    setTimeout(initAllCarousels, 100);
    return;
  }

  // Prevent double-init on elements already initialized
  function safeOwl(selector, options) {
    var el = jQuery(selector);
    if (el.length && !el.hasClass('owl-loaded')) {
      el.owlCarousel(options);
    }
  }

  safeOwl('.populartabcont .owl-carousel', {
    margin: 0, nav: true,
    responsive: {
      0:    { items: 1.5, stagePadding: 30, loop: true },
      400:  { items: 1.5, stagePadding: 30, loop: true },
      600:  { items: 3, loop: true },
      992:  { items: 4 },
      1200: { items: 5 }
    }
  });

  safeOwl('.newpopulartabcont .owl-carousel', {
    margin: 0, nav: true,
    responsive: {
      0:    { items: 1.5, stagePadding: 30, loop: true },
      400:  { items: 1.5, stagePadding: 30, loop: true },
      600:  { items: 3, loop: true },
      992:  { items: 4 },
      1200: { items: 5 }
    }
  });

  safeOwl('.helptodaysec .owl-carousel', {
    margin: 0, nav: true, autoplay: false, loop: true,
    responsive: {
      0:    { items: 1, stagePadding: 60 },
      400:  { items: 2, stagePadding: 60 },
      600:  { items: 2, stagePadding: 60 },
      992:  { items: 3 },
      1200: { items: 4 }
    }
  });

  safeOwl('.promicSec .owl-carousel', {
    margin: 10, nav: true, autoplay: true, loop: true,
    responsive: {
      0:    { items: 1, stagePadding: 40 },
      400:  { items: 2, stagePadding: 40 },
      600:  { items: 2, stagePadding: 40 },
      992:  { items: 3 },
      1200: { items: 4 }
    }
  });

  safeOwl('.promiRtcaro .owl-carousel', {
    margin: 20, nav: true, autoplay: false, loop: true,
    responsive: {
      0:    { items: 2, stagePadding: 40 },
      400:  { items: 2, stagePadding: 40 },
      600:  { items: 2, stagePadding: 40 },
      992:  { items: 3 },
      1200: { items: 5 }
    }
  });

  safeOwl('.promiccaro .owl-carousel', {
    margin: 20, nav: true, autoplay: true, loop: true,
    responsive: {
      0:    { items: 1 },
      1200: { items: 1 }
    }
  });

  safeOwl('.rtlogosec .owl-carousel', {
    margin: 20, nav: true, autoplay: false, loop: true,
    responsive: {
      0:    { items: 1 },
      400:  { items: 2 },
      576:  { items: 1 },
      600:  { items: 1 },
      992:  { items: 3 },
      1200: { items: 3 }
    }
  });
}

// Start polling immediately when DOM is ready
jQuery(document).ready(function () {
  initAllCarousels();
});


// =========================================================
// ALL ORIGINAL TAB / DROPDOWN / CLICK CODE — UNTOUCHED
// =========================================================

$('.tab-content').hide();
$('.newtab-content').hide();

$('#mySelect').change(function () {
  dropdown = $('#mySelect').val();
  $('.tab-content').hide();
  $('.normaltab').hide();
  $('.poptablst li').removeClass('actvs');
  $('#' + 'select-tab-' + dropdown).show();
});

$('#newmySelect').change(function () {
  console.log('upload');
  dropdown = $('#newmySelect').val();
  console.log(dropdown);
  $('.newtab-content').hide();
  $('.newnormaltab').hide();
  $('.newpoptablst li').removeClass('actvs');
  $('#' + 'newselect-tab-' + dropdown).show();
});

$(document).ready(function () {
  $('.poptablst a').click(function (event) {
    event.preventDefault();
    if ($(this).parents('.actvs').length) {
      $(this).parent().removeClass('actvs');
      $(this).parent().siblings().removeClass('w20a');
      $('.populartabcont').not(tab).css('display', 'none');
    } else {
      $(this).parent().addClass('actvs');
      $(this).parent().siblings().removeClass('actvs');
      $(this).parent().siblings().addClass('w20a');
      $(this).parent().removeClass('w20a');
      var tab = $(this).attr('href');
      $('.populartabcont').not(tab).css('display', 'none');
      $(tab).fadeIn();
    }
    $('.tab-content').hide();
    $('.normaltab').show();
  });

  $('.newpoptablst a').click(function (event) {
    console.log('tesxt');
    event.preventDefault();
    if ($(this).parents('.actvs').length) {
      $(this).parent().removeClass('actvs');
      $(this).parent().siblings().removeClass('w20a');
      $('.newpopulartabcont').not(tab).css('display', 'none');
    } else {
      $(this).parent().addClass('actvs');
      $(this).parent().siblings().removeClass('actvs');
      $(this).parent().siblings().addClass('w20a');
      $(this).parent().removeClass('w20a');
      var tab = $(this).attr('href');
      $('.newpopulartabcont').not(tab).css('display', 'none');
      $(tab).fadeIn();
    }
    $('.newtab-content').hide();
    $('.newnormaltab').show();
  });
});

$(document).ready(function () {
  $('.pomistab a').click(function (event) {
    event.preventDefault();
    $(this).parent().addClass('actv');
    $(this).parent().siblings().removeClass('actv');
    var tab = $(this).attr('href');
    $('.promicbtmthm').not(tab).css('display', 'none');
    $(tab).fadeIn();
  });
});

$('#mySelect').on('change', function (e) {
  console.log('download');
  $('#myTab li a').eq($(this).val()).tab('show');
});

$('#newmySelect').on('change', function (e) {
  console.log('download gh');
  $('#myTab li a').eq($(this).val()).tab('show');
});